/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'calculator-slider': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g _fill="#fff" fill-rule="evenodd"><path pid="0" d="M8 3a1 1 0 011 1v16a1 1 0 01-2 0V4a1 1 0 011-1zM12 3a1 1 0 011 1v16a1 1 0 01-2 0V4a1 1 0 011-1zM16 3a1 1 0 011 1v16a1 1 0 01-2 0V4a1 1 0 011-1zM2.354 11.646l1.792-1.792a.5.5 0 01.854.353v3.586a.5.5 0 01-.854.353l-1.792-1.792a.5.5 0 010-.708zM21.646 11.646l-1.792-1.792a.5.5 0 00-.854.353v3.586a.5.5 0 00.854.353l1.792-1.792a.5.5 0 000-.708z"/></g>'
  }
})
